// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"08ca1d90","239":"e34ce795","453":"e3e86ffb","455":"7a1335fb"}[chunkId] + ".chunk.js";
};